// Usage:
//  const instance = new FileUpload(url, onProgress)
//  return instance.upload(file)

class FileUpload {
  constructor(url, onProgress = () => {}) {
    this.url = url
    this.onProgress = onProgress
  }

  upload(inputs = {}) {
    let xhr = new XMLHttpRequest()

    xhr.responseType = 'json'

    // Headers
    xhr.open('POST', this.url, true)

    // Events
    xhr.upload.addEventListener('progress', this.onProgress, false)
    let promise = new Promise((resolve, reject) => {
      xhr.onload = e =>
        xhr.status >= 200 && xhr.status < 400 ? resolve(e) : reject(e)
      xhr.onerror = e => reject(e)
    })

    const formData = new FormData()
    for (const key of Object.keys(inputs)) {
      formData.append(key, inputs[key])
    }

    xhr.send(formData)

    return promise
  }
}

export default FileUpload
